/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {
    export class ProcessValidationService {

        constructor(private processService: ProcessService) { }

        private validatePhoneNumber(value) {
            if (!value) return true;
            var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
            if (value.match(phoneno)) {
                return true;
            } else {
                return false;
            }
        }

        private validateEmail(email) {
            if (!email) return true;
            var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
            return re.test(email);
        }

        private validateUrl(value) {
            if (!value) return true;
            return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
        }

        public validate(
            process: Wars.Domain.Model.Dtos.ProcessDto,
            forms: Wars.Domain.Model.Form[],
            processConfig: Wars.Domain.Model.ProcessConfiguration) {
            var returnObjects = [];

            forms.forEach(form => {
                var fields = Wars.Domain.Model.ProcessConfigurationUtilities.GetFields(form);

                for (var i = 0; i < fields.length; i++) {
                    const currentField = fields[i];
                    if (!currentField.schemaProperty.parentObjectSchema.isList) {
                        this.validateField(process, processConfig, form, currentField, returnObjects);
                    }
                }

                var sections = Enumerable.from(form.mySteps).selectMany(i => i.formSections).toArray();
                sections.forEach(section => {
                    if (section.objectSchema.isList) {
                        // Get current field value
                        let currentFormDataId = Object.keys(process.formJson[form.uniqueIdentifier])[0];
                        var list = process.formJson[form.uniqueIdentifier][currentFormDataId][section.objectSchema.uniqueIdentifier];

                        if (list && list.length > 0) {
                            var listId = section.objectSchema.uniqueIdentifier;
                            for (var rowIndex = 0; rowIndex < list.length; rowIndex++) {
                                var rowId = list[rowIndex].id;
                                for (var fieldIndex = 0; fieldIndex < section.fields.length; fieldIndex++) {
                                    var listField = section.fields[fieldIndex];
                                    this.validateField(process, processConfig, form, listField, returnObjects, listId, rowId);
                                }
                            }
                        }
                    }
                });
            });


            return returnObjects;
        }

        private validateField(
            process: Wars.Domain.Model.Dtos.ProcessDto,
            processConfig: Wars.Domain.Model.ProcessConfiguration,
            form: Wars.Domain.Model.Form,
            field: Wars.Domain.Model.Field,
            returnObjects: Array<any>,
            listId?: string,
            rowId?: string)
        {
            var value;

            // Only validate field if validation is configured for this field
            if (!field.regExPattern && !field.isRequired) return;

            // Only validate if form field is updatable
            if (!this.processService.isFieldUpdatable(process, processConfig, form, field)) return;

            // Get current field value
            let currentFormDataId = Object.keys(process.formJson[form.uniqueIdentifier])[0];

            if (listId !== undefined && rowId !== undefined) {
                var list : Array<any> = process.formJson[form.uniqueIdentifier][currentFormDataId][listId];
                var row = Enumerable.from(list).singleOrDefault(i => i.id === rowId);
                if (row !== undefined) {
                    value = row[field.schemaProperty.uniqueIdentifier];
                }
            } else {
                value = process.formJson[form.uniqueIdentifier][currentFormDataId][field.schemaProperty.uniqueIdentifier];
            }
            
            if (value == undefined) {
                value = "";
            }

            if (field.regExPattern) {
                const regEx = new RegExp(field.regExPattern);

                if (!value.match(regEx)) {
                    let newObj = this.getErrorObj(form, field, rowId, field.regularExpressionFailureMessage);

                    returnObjects.push(newObj);
                }
            }

            if (field.isRequired && value !== 0 && !value) {
                let newObj = this.getErrorObj(form, field, rowId, "is required.");

                returnObjects.push(newObj);
            }
        }

        private getErrorObj(
            form: Wars.Domain.Model.Form,
            field: Wars.Domain.Model.Field,
            rowId: string,
            message: string
            ) {
            let stepId = this.getStepIdOfField(form, field);
            let fieldName = field.schemaProperty.uniqueIdentifier;
            let label = field.schemaProperty.name;

            return {
                stepId: stepId,
                fieldId: fieldName,
                rowId: rowId,
                label: label,
                formId: form.uniqueIdentifier,
                message: message
            }; 
        }

        public getStepIdOfField(form: Wars.Domain.Model.Form, field: Wars.Domain.Model.Field): string {

            if (form.mySteps) {
                for (var i = 0; i < form.mySteps.length; i++) {
                    var currentStepId = form.mySteps[i].id;
                    if (form.mySteps[i].formSections) {
                        for (var x = 0; x < form.mySteps[i].formSections.length; x++) {
                            if (field.formSection_id == form.mySteps[i].formSections[x].id) return currentStepId;
                        }
                    }
                }
            }
            return "-13";
        }
    }
}

warsApp.registerService('ProcessValidationService', ["processService"]);